import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Seo } from "@/components/Seo";
import { EnquiryForm } from "@/components/EnquiryForm";

export default function RequestQuote() {
  const [params] = useSearchParams();
  const product = params.get("product") || "";

  return (
    <div data-testid="quote-page">
      <Seo
        title="Request a Quote — Shineni India Denim Manufacturing"
        description="Request a factory quote for bulk denim jeans: share your product range, quantity, specifications and destination with Shineni India, Faridabad."
      />

      <section className="border-b border-border bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Factory-direct quotation</p>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-semibold text-indigo sm:text-5xl">
            Request a quote
          </h1>
          <p className="mt-4 max-w-2xl text-base text-foreground/70">
            Pricing is quoted per program — share your range, quantity, specifications and
            destination and our team will respond with a written offer.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <EnquiryForm
            variant="quote"
            defaultProduct={product}
            title="Tell us your requirement"
            subtitle="The more detail you share, the sharper our quote."
          />
        </motion.div>
      </section>
    </div>
  );
}
